import React from 'react'
import Layout from './src/containers/Layout'
import { MenuProvider } from './src/state'

export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>
}

export function wrapRootElement({ element }) {
  return <MenuProvider>{element}</MenuProvider>
}
